import { Alert, CopyValue, ToggleContainer } from '@components'
import { getImportSourceLabelKey, IImportData } from '@query'
import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TransactionDetails } from '../TransactionDetails'

export const DocumentBankDetails: React.FC<{ import_data: IImportData }> = ({ import_data }) => {
  const { t } = useTranslation()

  return (
    <>
      <Alert
        description={t(
          `document.importSource.alertDescription.${getImportSourceLabelKey(
            import_data.data_source
          )}`
        )}
      />

      <TransactionDetails import_data={import_data} />

      <ToggleContainer title={t('document.importDetails.traceId')}>
        <DetailRow>
          <StyledHeader>{t('document.importDetails.traceIdDescription')}</StyledHeader>
          <StyledValue>
            <CopyValue value={import_data.trace_id || '-'} />
          </StyledValue>
        </DetailRow>
      </ToggleContainer>
    </>
  )
}

const DetailRow = styled.div`
  flex: 1;
  margin-bottom: ${({ theme }) => theme.spacing.lg}rem;
`

const StyledHeader = styled.p`
  color: ${({ theme }) => theme.colors.metalGray};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  margin-bottom: ${({ theme }) => theme.spacing.xxs}rem;
  align-self: flex-start;
`

const StyledValue = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  color: ${({ theme }) => theme.colors.neutralBlack};
  margin: 0;
`
